import { AxiosError } from 'axios';
import { FC } from 'react';

import ContactAdmin from '../pages/ContactAdmin';

interface FallbackProps<T extends Error> {
  error: T;
}

const ErrorFallback: FC<FallbackProps<AxiosError>> = ({ error }) => <ContactAdmin error={error} />;

export default ErrorFallback;
